<template>
  <div class="attributes col-12">
      <template v-for="item in list">
          <Variations :key="item.attribute" :attribute="item.attribute" :errors="errors"/>
      </template>

      <label>Аттрибуты</label>
      <fieldset class="form-group mb-3 d-flex">
          <select
              class="
                single-select
                w-100
                mb-3
                categories-select
                ms-offscreen
              "
              v-model="attribute"
          >
              <option value="">Выбрать аттрибуты</option>
              <option
                  v-for="attributes in attributes"
                  v-bind:value="attributes.attribute_id"
              >
                  <!-- :disabled="editChild && product.attributes.length === 0" -->
                  {{
                      attributes.detail == null
                          ? ""
                          : attributes.detail[0]
                              ? attributes.detail[0].name
                              : ""
                  }}
              </option>
          </select>
          <button
              type="button"
              @click.prevent="addVariations()"
              class="btn-secondary btn ml-2 white pt-2 pb-1"

          >
<!--                  :disabled="editChild"-->
              Добавить
          </button>
<!--          <button-->
<!--              type="button"-->
<!--              @click.prevent="unsetVariationData()"-->
<!--              class="btn-secondary btn ml-2 white pt-2 pb-1"-->

<!--              v-show="displayClearBtn"-->
<!--          >-->
<!--&lt;!&ndash;                  :disabled="editChild == true"&ndash;&gt;-->
<!--              Убрать-->
<!--          </button>-->
      </fieldset>
      <small
          class="form-text text-danger"
          v-if="errors.has('attributes')"
          v-text="errors.get('attributes')"
      ></small>
  </div>
</template>

<script>
import Variations from './Variations';
export default {
    components: {
        Variations,
    },
    name: "Attributes",
    props: {
        attributes: {
            type: Array,
            required: true
        },
        errors: []
    },
    data(){
        return {
            attribute: '',
            list: [],
        }
    },
    methods: {
        addVariations(){
            this.list.push({
                attribute: this.attribute,
                value: null
            })
        }
    }
}
</script>

<style scoped>

</style>
